import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Empregador } from '../../api.service';
import { ServicoAutenticacao } from '../../core/auth/servico-autenticacao';
import { ServicoTenant } from '../../core/tenant/servico-tenant';
import { ServicoPortalServidor } from './servico-portal-servidor';

@Component({
  selector: 'app-tela-login-servidor',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './tela-login-servidor.component.html',
  styleUrls: ['../login/tela-login.component.css']
})
export class TelaLoginServidorComponent implements OnInit {
  cpf = '';
  senha = '';
  senhaVisivel = false;
  mensagem = '';
  tenant?: Empregador;

  constructor(
    private readonly servicoAutenticacao: ServicoAutenticacao,
    private readonly servicoPortalServidor: ServicoPortalServidor,
    private readonly servicoTenant: ServicoTenant,
    private readonly roteador: Router
  ) {}

  get nomeEmpresa() {
    return this.tenant?.nomeFantasia || this.tenant?.razaoSocial || 'Ponto JWM';
  }

  get logo() {
    return this.servicoPortalServidor.logo(this.tenant);
  }

  get iniciais() {
    return this.servicoPortalServidor.iniciais(this.nomeEmpresa);
  }

  ngOnInit() {
    if (this.servicoAutenticacao.possuiToken && this.servicoAutenticacao.usuarioLogado?.perfil === 'SERVIDOR') {
      this.roteador.navigate(['/servidor']);
      return;
    }
    this.servicoPortalServidor.buscarTenant().subscribe({
      next: tenant => this.tenant = tenant,
      error: () => {
        if (this.servicoTenant.slugTenantAtual) {
          this.mensagem = 'Portal nao configurado para este dominio.';
        }
      }
    });
  }

  mascararCpf() {
    this.cpf = this.servicoPortalServidor.mascararCpfDigitado(this.cpf);
  }

  entrar() {
    const cpf = this.servicoPortalServidor.cpfParaLogin(this.cpf);
    if (cpf.length !== 11) {
      this.mensagem = 'Informe o CPF com 11 digitos.';
      return;
    }
    this.servicoAutenticacao.entrar(cpf, this.senha, this.servicoTenant.slugTenantAtual || undefined).subscribe({
      next: resposta => {
        if (resposta.usuario.perfil !== 'SERVIDOR') {
          this.servicoAutenticacao.sair();
          this.roteador.navigate(['/menu']);
          return;
        }
        this.roteador.navigate(['/servidor']);
      },
      error: () => this.mensagem = 'CPF ou senha invalidos.'
    });
  }
}
